import React from "react";
export default () =><svg width="100%"
height="100%" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M43.7197 30C44.5488 27.6542 45 25.1298 45 22.5C45 19.8702 44.5488 17.3458 43.7197 15H1.28029C0.451157 17.3458 0 19.8702 0 22.5C0 25.1298 0.451157 27.6542 1.28029 30H43.7197Z" fill="#FF0000"/>
<path d="M22.4 45C12.5201 45 4.11499 38.7389 1 30H43.8C40.6849 38.7389 32.2799 45 22.4 45Z" fill="#FFCC00"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 0C12.7034 0 4.36902 6.26111 1.28027 15H43.7197C40.6309 6.26111 32.2966 0 22.5 0Z" fill="black"/>
</svg>
